var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white",
    strokeOpacity: 0.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 18.8604C33.8452 19.3078 33.0764 19.5454 32.2907 19.5432C33.1308 19.0334 33.7597 18.2235 34.0581 17.2674C33.3618 17.8738 32.4843 18.2153 31.5727 18.2346C30.9716 17.6005 30.1871 17.1843 29.3369 17.0484C28.4867 16.9126 27.6167 17.0644 26.8574 17.4811C26.098 17.8978 25.4904 18.557 25.1256 19.3596C24.7609 20.1622 24.6586 21.0651 24.8343 21.9327C23.2874 21.8485 21.775 21.4302 20.3953 20.7049C19.0155 19.9796 17.7993 18.9635 16.8256 17.7226C16.3491 18.6107 16.2096 19.6494 16.4341 20.6374C16.6586 21.6254 17.2311 22.4924 18.0407 23.0705C17.4297 23.0794 16.8249 22.9431 16.2733 22.6723C16.2881 23.5887 16.6009 24.4735 17.1617 25.1852C17.7224 25.8969 18.4987 26.3943 19.3663 26.5979C18.7887 26.7532 18.1847 26.7727 17.5988 26.6548C17.8516 27.4666 18.3439 28.1771 19.0073 28.687C19.6706 29.1969 20.4719 29.4809 21.2994 29.4994C19.5517 30.5915 17.5441 31.1627 15.5 31.1493C17.212 32.3005 19.2005 32.9398 21.2442 32.996C23.288 33.0521 25.3068 32.5229 27.0759 31.4673C28.8449 30.4117 30.2949 28.871 31.2644 27.0169C32.2338 25.1628 32.6847 23.0679 32.5669 20.9655C33.2957 20.3515 33.9453 19.6441 34.5 18.8604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem3);
export default __webpack_public_path__ + "static/media/item (3).16f6f2e2fa957017d7725f24b222c34f.svg";
export { ForwardRef as ReactComponent };